import { category_search_page } from "@core/gql-mockups/categories";

const { minimize_str } = require("@core/helpers/string");

export const GET_CATEGORY_BY_SLUG = ({ category_search_page_mockup }) => minimize_str(`
  query ($slug: String, $type:Int) {
    result: getCategoryBySlug(slug: $slug, type:$type) ${category_search_page_mockup || category_search_page}
  }
`);

export const GET_CATEGORIES = ({ category_search_page_mockup }) => minimize_str(`
  query ($page: Int, $limit:Int, $filter:CategoryFilter, $sort:CategorySort) {
    result: getCategories(page:$page, limit:$limit, filter:$filter, sort:$sort) {
      paginate {
        total
        pages
      }
      data ${category_search_page_mockup || category_search_page}
    }
  }
`);

export const GET_ALL_CATEGORIES = ({ categories_mockup }) => minimize_str(`
  query ($filter:CategoryFilter, $sort:CategorySort) {
    result: getAllCategories(filter:$filter, sort:$sort) ${categories_mockup || category_search_page}
  }
`);
